import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { map } from 'rxjs/operators';
import { EnvironmentService } from '../../service/service.module';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MasterProductService {

  environment = EnvironmentService.environment;

  //Variables
  selectedMasterItem: any;

  // Subjects
  public masterGridActionCellSubject: Subject<any> = new Subject();

  /* Set Subjects for HEADER COLUMN EDIT/REMOVE */
  setMasterGridActionCellSubject = (value: any) => { this.masterGridActionCellSubject.next(value); };

  // Observables
  getMasterGridActionCellSubject = () => this.masterGridActionCellSubject.asObservable();


  constructor(private http: HttpClient) {
  }


  CreateMasterItem(masterItem: any) {
    return this.http.post<any>(`${this.environment.AppMasterItem}/add`, masterItem)
      .pipe(map(data => {
        return data;
      }));
  }

  UpdateMasterItem(masterItem: any) {
    return this.http.put(`${this.environment.AppMasterItem}/update`, masterItem)
      .pipe(map(data => {
        return data;
      }));
  }

  DeleteMasterItem(masterItemId: string) {
    return this.http.delete(`${this.environment.AppMasterItem}/delete?MasterItemId=${masterItemId}`)
      .pipe(map(data => {
        return data;
      }));
  }

  GetAllMasterItems(requestBody: any) {
    return this.http.post(`${this.environment.AppMasterItem}/getall`, requestBody)
      .pipe(map(data => {
        return data;
      }));
  }

  GetFilterMasterItemList(body: any) {
    const query = Object.keys(body).map(key => {
      return `${key}=${body[key]}`;
    }).join('&');
    return this.http.get(`${this.environment.AppMasterItem}/getlist?${query}`)
      .pipe(map(data => {
        return data;
      }));
  }

  ExportMasterDataTemplate() {
    return this.http.get(`${this.environment.AppMasterItem}/getexporttemplate`)
      .pipe(map(data => {
        return data;
      }));
  }

  ImportMasterDataTemplate(body: any) {
    return this.http.post(`${this.environment.AppMasterItem}/import`, body)
      .pipe(map(data => {
        return data;
      }));
  }

}
